export default {
  'connectionGroupConfig.title': 'Gestionar Grupos de Conexiones',
};
